export const REGULAR_VAT = 'regular_VAT'
export const EU_VAT = 'EU_VAT'
export const INVERTED_VAT = 'inverted_VAT'
export const NO_VAT = 'no_VAT'
